@import '~style-sheet-helpers/core.less';

.print-modal {
  width: 1200px;
  height: 700px;
}

.print-modal-body {
  height: 100%;
  overflow: hidden;
}

.print-modal-footer {
  button {
    margin-right: 10px;
  }
  button:last-child {
    margin-right: 0;
  }
  display: flex;
  justify-content: flex-end;
  &.void-container {
    justify-content: space-between;
  }
}
